import FindLocationResultState from '../data/schema/FindLocationResultState';
import { isNullOrWhiteSpace } from 'owa-string-utils';

/**
 * function to get the first index in the UI of the results returned by FindPlace API.
 * The offset is 0 if we don't show "use this location", and 1 otherwise.
 * @param findLocationResultState: the find location dropdown state
 * @param disableUseThisLocation: indicates if the control will show use this location or not
 */
export default function getFindResultsOffset(
    findLocationResultState: FindLocationResultState,
    disableUseThisLocation: boolean
): number {
    return isNullOrWhiteSpace(findLocationResultState.queryString) || disableUseThisLocation
        ? 0
        : 1;
}
